import script from "./UserInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserInfo.vue?vue&type=script&lang=ts&setup=true"

import "./UserInfo.vue?vue&type=style&index=0&id=a2a6b4a6&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a2a6b4a6"]])

export default __exports__